import { locale } from '../lib/locale';

/**
 * Texts of "Konto löschen" (1.17). German is the master; English (1.19) has the same keys.
 */
export const ACCOUNT_TEXT = {
  de: {
    entry: 'Konto löschen',
    title: 'Konto löschen',
    whatGoes:
      'Dein Konto wird endgültig gelöscht: deine Anmeldung, deine E-Mail-Adresse und dein Feedback an uns.',
    personStays: (name: string) =>
      `${name} bleibt in der Familie – mit Aufgaben und Sternen, nur ohne eigene Anmeldung. Die Eltern können die Person später entfernen.`,
    familyGoes: (family: string) =>
      `Du bist der einzige Elternteil mit eigenem Konto. Darum wird ${family} mit gelöscht – alle Personen, Termine, Aufgaben und Sterne. Wanddisplays und Konten der Großen werden abgemeldet.`,
    exportTip: 'Tipp: Vorher unter Einstellungen → Familie alle Daten herunterladen.',
    sectionTitle: 'Dein Konto',
    signedInAs: (email: string) => `Angemeldet als ${email}`,
    googleManaged: 'Du meldest dich mit Google an – deine Adresse verwaltet Google.',
    changeEntry: 'E-Mail ändern',
    changeTitle: 'E-Mail-Adresse ändern',
    changeIntro:
      'An die neue Adresse schicken wir einen Bestätigungslink. Bis du ihn öffnest, bleibt alles, wie es ist.',
    newEmail: 'Neue E-Mail-Adresse',
    changeSend: 'Bestätigungslink schicken',
    changeSent: (email: string) =>
      `Schau in dein Postfach bei ${email}. Bis du bestätigst, bleibt alles, wie es ist.`,
    changedTitle: 'E-Mail geändert',
    changedText: 'Deine neue Adresse gilt. Melde dich ab jetzt damit an.',
    toLogin: 'Zur Anmeldung',
    password: 'Zur Sicherheit: dein Passwort',
    google: 'Zur Sicherheit meldest du dich gleich noch einmal bei Google an.',
    confirm: 'Konto endgültig löschen',
    cancel: 'Abbrechen',
    busy: 'Wird gelöscht …',
    goodbye: 'Dein Konto ist gelöscht. Schön, dass du dabei warst.',
  },
  en: {
    entry: 'Delete account',
    title: 'Delete account',
    whatGoes:
      'Your account will be deleted for good: your sign-in, your email address and your feedback to us.',
    personStays: (name: string) =>
      `${name} stays in the family – with tasks and stars, just without their own sign-in. Parents can remove them later.`,
    familyGoes: (family: string) =>
      `You are the only parent with your own account. So ${family} will be deleted too – all people, events, tasks and stars. Wall displays and the older kids’ accounts will be signed out.`,
    exportTip: 'Tip: first download all your data under Settings → Family.',
    sectionTitle: 'Your account',
    signedInAs: (email: string) => `Signed in as ${email}`,
    googleManaged: 'You sign in with Google – Google manages your address.',
    changeEntry: 'Change email',
    changeTitle: 'Change email address',
    changeIntro:
      'We’ll send a confirmation link to the new address. Until you open it, everything stays as it is.',
    newEmail: 'New email address',
    changeSend: 'Send confirmation link',
    changeSent: (email: string) =>
      `Check your inbox at ${email}. Until you confirm, everything stays as it is.`,
    changedTitle: 'Email changed',
    changedText: 'Your new address is active. Use it to sign in from now on.',
    toLogin: 'Go to sign-in',
    password: 'For your security: your password',
    google: 'For your security, you’ll sign in with Google once more.',
    confirm: 'Delete account for good',
    cancel: 'Cancel',
    busy: 'Deleting …',
    goodbye: 'Your account has been deleted. Thank you for being part of it.',
  },
} as const;

export const accountText = ACCOUNT_TEXT[locale];
